
import Vue from "vue";
import ChapterItem from './ChapterItem.vue'
import { INode, ISearchNode } from "@/shared/models/node.model";
import { tdApi } from "@/services/td/td.api.service";
import { HtmlHelper } from "@/shared/lib/htmlhelper";

export default Vue.extend({
  name: "ChapterMenu",
  props: {
    startNodeId: Number,
    tree: Array as () => INode[],
    mobileMenuOpen: Boolean
  },
  components: {
    ChapterItem
  },
  data() {
    return {
      activeNodeId: 0 as number,
      isMobileMenuOpen: false as boolean,
      isMenuButtonHidden: false as boolean,
      isSearchActive: false as boolean,
      query: "" as string,
      searchResult: [] as ISearchNode[],
      wait: false as boolean,
      searchTimeout: 0
    };
  },
  watch: {
    startNodeId(value: number) {
      if (value > 0) {
        this.activeNodeId = value;
      }
    },
    isSearchActive(value: boolean) {
      const audioCue = document.getElementById("audio-cue-search");
      if (value) {
        audioCue!.innerHTML = "Sökfunktionen är aktiverad.";
      } else {
        this.searchResult = [];
        this.query = "";
        audioCue!.innerHTML = "Kapitellistan är aktiverad.";
      }
    },
    async query(value: string) {
      if (value.length > 2 && this.isSearchActive) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(async () => {
          this.wait = true;
          this.searchResult = await tdApi.searchNodes(value);

          const audioCue = document.getElementById("audio-cue-result");
          audioCue!.innerHTML = `${this.searchResult.length} träffar, använd tab-tangenten för att navigera i resultatet.`;

          this.wait = false;
        }, 500);
      } else {
        this.searchResult = new Array<ISearchNode>();
      }
    }
  },
  mounted() {
    this.isMobileMenuOpen = this.mobileMenuOpen;
  },
  methods: {
    showTree(selectedChapter: INode) {
      this.$emit("show-tree", selectedChapter);
    },

    toggleMenu(): void {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      this.isMenuButtonHidden = !this.isMenuButtonHidden;
      this.isSearchActive = false;
      if (this.isMobileMenuOpen) {
        document.documentElement.classList.add("no-scroll");
      } else {
        document.documentElement.classList.remove("no-scroll");
      }
      this.$emit("toggle-Menu", this.isMobileMenuOpen);
    },

    getFullUrl(url: string): string {
      const helper = new HtmlHelper();
      const baseUrl = helper.getBaseUrl();

      return `${baseUrl}${url}`;
    },
  },
});
